import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import ManualManager from './ManualManager';
import ActivityManager from "./ActivityManager";

class ManualStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }


  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.MANUALS_FETCH:
        ManualManager.fetch();
        return state;

      case ActionTypes.MANUALS_FETCH_COMPLETE:
        return action.collections;

      case ActionTypes.MANUAL_SAVE_ACTIVITY_FETCH:
        ActivityManager.saveActivity({
          collection_id: action.collectionId,
          manual_id: action.manualId,
          event_type: 'collection_manual_viewed'
        }, 'collection-manual-activities');
        return state;

      default:
        return state;
    }
  }
}

export default new ManualStore();
